import { render, staticRenderFns } from "./detailContact.vue?vue&type=template&id=2e4bbc36&"
import script from "./detailContact.vue?vue&type=script&lang=js&"
export * from "./detailContact.vue?vue&type=script&lang=js&"
import style0 from "./detailContact.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports